import { Deserializable } from '../protocols/deserializable';
import { Address } from '../users/dto/address';
import { SpouseDetailFormGroup } from '../shared/forms/spouse-detail-form-group';

export class RelationshipStatusSubmissionSpouse implements Deserializable {
  public spouseId: number | null = null;
  public firstName: string = '';
  public middleName: string | null = null;
  public lastName: string = '';
  public socialInsuranceNumber: string | null = null;
  public email: string = '';
  public phoneNumberCountryCode: string = '';
  public phoneNumber: string = '';
  public birthDate: string = '';
  public address!: Address;

  public formattedSIN: string = '';

  public static fromSpouseDetailForm(spouseDetailForm: SpouseDetailFormGroup): RelationshipStatusSubmissionSpouse {
    const spousePersonalInfoFormGroup = spouseDetailForm.controls.spousePersonalInfo;
    const spouseContactDetailsFormGroup = spouseDetailForm.controls.spouseContactDetails;

    const instance = new RelationshipStatusSubmissionSpouse();

    instance.spouseId = spouseDetailForm.controls.spouseId.value;
    instance.firstName = spousePersonalInfoFormGroup.controls.firstName.value;
    instance.middleName = spousePersonalInfoFormGroup.controls.middleName?.value;
    instance.lastName = spousePersonalInfoFormGroup.controls.lastName.value;
    instance.socialInsuranceNumber = spousePersonalInfoFormGroup.controls.sin.value || null;
    instance.birthDate = spousePersonalInfoFormGroup.controls.dateOfBirth.value;
    instance.email = spouseContactDetailsFormGroup.controls.email.value;
    instance.phoneNumberCountryCode = spouseContactDetailsFormGroup.controls.phoneNumberCountryCode.value;
    instance.phoneNumber = spouseContactDetailsFormGroup.controls.phoneNumber.value;

    const address = spouseContactDetailsFormGroup.controls.address.getRawValue();
    instance.address = window.injector.Deserialize.instanceOf(Address, {
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2 || null,
      addressLine3: address.addressLine3 || null,
      city: address.city,
      stateId: address.stateId,
      countryId: address.countryId,
      postalCode: address.postalCode
    });

    return instance;
  }

  public onDeserialize() {
    if (this.address) {
      this.address = window.injector.Deserialize.instanceOf(Address, this.address);
    }

    if (!!this.socialInsuranceNumber) {
      this.formattedSIN = this.socialInsuranceNumber.replace(/(\d{3})(\d{3})(\d{3})/, '*** *** $3');
    }
  }
}
